import { Bundle } from '../types/bundle.types';

// Helper function to convert createdOn to a timestamp (in milliseconds)
const getTimestamp = (createdAt: number | string): number => {
  if (typeof createdAt === 'number') return createdAt;
  // Convert string date into an ISO format if needed (replace space with "T")
  const isoString = createdAt.includes('T')
    ? createdAt
    : createdAt.replace(' ', 'T');
  return new Date(isoString).getTime();
};

/**
 * Sorts a list of bundles based on their status and creation date.
 *
 * @param {Bundle[]} arr - The array of bundles to sort.
 * @returns {Bundle[]} - The sorted array of bundles.
 */
export const sortBundleList = (arr: Bundle[]): Bundle[] => {
  if (!arr || arr.length === 0) return [];

  const statusOrder: { [key in Bundle['status']]: number } = {
    active: 0,
    suspended: 2,
    deleted: 3,
  };

  return arr.sort((a, b) => {
    // Compare statuses based on order status.
    const statusA = statusOrder[a.status];
    const statusB = statusOrder[b.status];

    if (statusA !== statusB) {
      return statusA - statusB;
    }

    // For equal statuses, sort by createdOn (in descending order)
    const timestampA = getTimestamp(a.createdAt);
    const timestampB = getTimestamp(b.createdAt);
    return timestampB - timestampA;
  });
};

